import type { EntityState } from '@reduxjs/toolkit';

export const BILL_SCOUT_RECORDED_TRANSACTIONS_REDUCER_KEY = 'billScoutRecordedTransactionsStore';
export type BILL_SCOUT_RECORDED_TRANSACTIONS_REDUCER_KEY = typeof BILL_SCOUT_RECORDED_TRANSACTIONS_REDUCER_KEY;

export type BillScoutRecordedTransaction = {
  id: string;
  transactionId: string;
  recordedScheduleId: string;
};

export type FetchBillScoutRecordedTransactionsPayload = {
  stModelId: string;
};

export type AddBillScoutRecordedTransactionsPayload = {
  stModelId: string;
  transactionIds: ReadonlyArray<string>;
};

/** The DELETE endpoint accepts the recorded-association id, not a transaction id. */
export type DeleteBillScoutRecordedTransactionPayload = {
  stModelId: string;
  recordedTransactionId: string;
};

export type BillScoutRecordedTransactionsRequestStatus = 'idle' | 'pending' | 'succeeded' | 'failed';

export const BILL_SCOUT_RECORDED_TRANSACTIONS_REQUEST_ERROR = 'BILL_SCOUT_RECORDED_TRANSACTIONS_REQUEST_ERROR';

export type BillScoutRecordedTransactionsRequestError = {
  type: typeof BILL_SCOUT_RECORDED_TRANSACTIONS_REQUEST_ERROR;
  ambiguous: boolean;
  message: string;
  status?: number;
  code?: string;
};

export type BillScoutRecordedTransactionsModelState = {
  associationIds: string[];
  dataRevision: number;
  hasLoaded: boolean;
  fetch: {
    status: BillScoutRecordedTransactionsRequestStatus;
    error: BillScoutRecordedTransactionsRequestError | null;
    requestId: string | null;
    startedDataRevision: number | null;
  };
  mutation: {
    status: BillScoutRecordedTransactionsRequestStatus;
    error: BillScoutRecordedTransactionsRequestError | null;
    pendingRequestIds: string[];
  };
  needsReconciliation: boolean;
};

export type BillScoutRecordedTransactionsState = EntityState<BillScoutRecordedTransaction, string> & {
  models: Record<string, BillScoutRecordedTransactionsModelState>;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [BILL_SCOUT_RECORDED_TRANSACTIONS_REDUCER_KEY]: BillScoutRecordedTransactionsState;
  }
}
